import type { PropsWithChildren } from 'react';
import * as React from 'react';

import AccountPageHeader from 'bundles/composable-page-header-consumer/header-renderers/AccountPageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';

type Props = PropsWithChildren;

export const PreferenceCenterApp = ({ children }: Props) => {
  return (
    <div className="rc-PreferenceCenterApp">
      <UniversalPageFeatures />
      <AccountPageHeader />
      {children}
      <PageFooter />
    </div>
  );
};

export default PreferenceCenterApp;
